import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const header = () => {
  const state = {
    isOpen: false
  };

  const body = document.querySelector('body');
  const headerElement = document.querySelector('.header');
  const nav = headerElement.querySelector('nav');
  const navBurger = headerElement.querySelector('.nav-btn');
  const navLinks = headerElement.querySelectorAll('.nav-list li');

  if (body.classList.contains('home')) {
    const section = document.querySelector('.below-hero');

    gsap.to(headerElement, 0.1, {
      '--height': '100%',
      ease: 'power1.inOut',
      scrollTrigger: {
        trigger: section,
        start: () => 'top top+=' + headerElement.offsetHeight,
        toggleActions: 'play none none reverse'
      }
    });
  }

  const navTimeline = gsap.timeline({
    paused: true,
    ease: 'power1.inOut'
  }).to(nav, 0.4, {
    x: '100%',
    display: 'block',
  }).from(navLinks, {
    autoAlpha: 0,
    x: 10,
    stagger: {
      amount: 0.4
    }
  }, 0.4);

  const showNavigation = () => {
    state.isOpen = true;
    headerElement.classList.add('nav-open');
    body.classList.add('overflow-hidden-mobile');
    navTimeline.timeScale(1).play();
  };

  const hideNavigation = () => {
    state.isOpen = false;
    navTimeline.timeScale(2).reverse();
    headerElement.classList.remove('nav-open');
    body.classList.remove('overflow-hidden-mobile');
  };

  const toggleNavigation = () => {
    if (state.isOpen) {
      hideNavigation();
    } else {
      showNavigation();
    }
  };

  navBurger.addEventListener('click', () => {
    toggleNavigation();
  });
};

export default header;
